import _ from 'lodash';

import DocumentPoint from './models/DocumentPoint';

export default class ClusterData {
  private documentPointsById: object = {};
  private documentDataPoints: object[];
  private clusterInfoData: any;
  private documentInfoData: any;

  constructor() {
    this.documentInfoData = null;
    this.clusterInfoData = null;
  }

  getDocumentInfoData(): DocumentPoint[] {
    return _.cloneDeep(this.documentInfoData);
  }

  getClusterInfoData() {
    return _.cloneDeep(this.clusterInfoData);
  }

  setDocumentInfoData(data) {
    this.documentInfoData = data;
  }

  setClusterInfoData(data) {
    this.clusterInfoData = data;
  }

  getDocumentPointById(documentId): DocumentPoint {
    return this.documentPointsById[documentId];
  }

  updateDocumentPoints(documentDataPoints) {
    for (const doc of documentDataPoints) {
      this.documentPointsById[doc.getId()] = doc;
    }
  }

  setDocumentDataPoints(documentDataPoints) {
    this.documentDataPoints = documentDataPoints;
  }
}
